/**
 * @flow
 * @relayHash 08ec106c3626f7ec6f00727cd1cdbcf8
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ProjectTrackStatusEnum = ('Active' | 'Deleted' | '%future added value');
export type projectUpdate_MutationVariables = {|
  input: {
    id: string,
    name?: ?string,
    nodes?: ?string,
    license_params?: ?$ReadOnlyArray<?{
      spot_count?: ?number,
      term?: ?number,
      medium: number,
      contextual_param?: ?$ReadOnlyArray<?number>,
      contextual_param_type: string,
    }>,
    is_public?: ?boolean,
    tracks?: ?{
      add?: ?$ReadOnlyArray<?{
        track_id: string,
        version: string,
      }>,
      update?: ?$ReadOnlyArray<?{
        id: string,
        version?: ?string,
        status?: ?ProjectTrackStatusEnum,
      }>,
      remove?: ?$ReadOnlyArray<?{
        id: string,
      }>,
    },
    clientMutationId?: ?string,
  },
|};
export type projectUpdate_MutationResponse = {|
  +updateProject: ?{|
    +project: ?{|
      +id: string,
      +is_public: ?boolean,
      +name: string,
      +tracks: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +id: string,
          +version: string,
          +node: ?{|
            +id: string,
            +internal_id: ?number,
            +price: ?number,
            +base_price: ?number,
            +title: ?string,
            +added_to_cart: ?boolean,
            +slug: ?string,
            +duration: ?number,
            +score: ?number,
            +boosted_score: ?number,
            +stems_available: ?boolean,
            +customizable: ?boolean,
            +matched_exclusions: ?$ReadOnlyArray<?number>,
            +tempos: ?$ReadOnlyArray<?{|
              +id: string,
              +name: ?string,
              +value: ?number,
            |}>,
            +assets: ?$ReadOnlyArray<?{|
              +id: string,
              +version: ?string,
              +type: ?string,
              +file_format: ?string,
              +path: ?string,
              +metadata: ?any,
            |}>,
            +artist: ?{|
              +id: string,
              +name: ?string,
              +slug: ?string,
              +bio: ?string,
              +bandcamp: ?string,
              +facebook: ?string,
              +instagram: ?string,
              +itunes: ?string,
              +soundcloud: ?string,
              +spotify: ?string,
              +twitter: ?string,
              +wiki: ?string,
              +youtube: ?string,
              +homebase: ?string,
              +assets: ?$ReadOnlyArray<?{|
                +id: string,
                +version: ?string,
                +type: ?string,
                +file_format: ?string,
                +path: ?string,
                +metadata: ?any,
              |}>,
            |},
            +terms: ?{|
              +edges: ?$ReadOnlyArray<?{|
                +node: ?{|
                  +id: string,
                  +is_highlighted: ?boolean,
                  +name: ?string,
                  +parent_id: ?string,
                  +taxonomy: ?{|
                    +id: string,
                    +internal_id: ?number,
                    +name: ?string,
                  |},
                |},
              |}>,
            |},
            +collections: ?{|
              +edges: ?$ReadOnlyArray<?{|
                +node: ?{|
                  +id: string,
                  +description: ?string,
                  +name: string,
                  +slug: ?string,
                  +category: ?{|
                    +id: string,
                    +name: ?string,
                  |},
                  +assets: ?$ReadOnlyArray<?{|
                    +id: string,
                    +version: ?string,
                    +type: ?string,
                    +file_format: ?string,
                    +path: ?string,
                    +metadata: ?any,
                  |}>,
                |},
              |}>,
            |},
            +association_id: ?string,
            +selected_version: ?string,
          |},
        |}>,
      |},
      +license_params: ?$ReadOnlyArray<?{|
        +spot_count: ?number,
        +term: ?number,
        +medium: number,
        +contextual_param: ?$ReadOnlyArray<?number>,
        +contextual_param_type: string,
      |}>,
    |},
  |},
|};
*/


/*
mutation projectUpdate_Mutation(
  $input: UpdateProjectInput!
) {
  updateProject(input: $input) {
    project {
      id
      is_public
      name
      tracks(first: 100) {
        edges {
          id
          version
          node {
            id
            internal_id
            price
            base_price
            title
            added_to_cart
            slug
            duration
            score
            boosted_score
            stems_available
            customizable
            matched_exclusions
            tempos {
              id
              name
              value
            }
            assets {
              id
              version
              type
              file_format
              path
              metadata
            }
            artist {
              id
              name
              slug
              bio
              bandcamp
              facebook
              instagram
              itunes
              soundcloud
              spotify
              twitter
              wiki
              youtube
              homebase
              assets {
                id
                version
                type
                file_format
                path
                metadata
              }
            }
            terms(first: 100) {
              edges {
                node {
                  id
                  is_highlighted
                  name
                  parent_id
                  taxonomy {
                    id
                    internal_id
                    name
                  }
                }
              }
            }
            collections {
              edges {
                node {
                  id
                  description
                  name
                  slug
                  category {
                    id
                    name
                  }
                  assets {
                    id
                    version
                    type
                    file_format
                    path
                    metadata
                  }
                }
                id
              }
            }
            association_id
            selected_version
            __typename
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
      license_params {
        spot_count
        term
        medium
        contextual_param
        contextual_param_type
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateProjectInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateProjectInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "is_public",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "version",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "stems_available",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "price",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "base_price",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "added_to_cart",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "duration",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "score",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "boosted_score",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "internal_id",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "customizable",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "matched_exclusions",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "tempos",
  "storageKey": null,
  "args": null,
  "concreteType": "Tempo",
  "plural": true,
  "selections": [
    v2,
    v4,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "value",
      "args": null,
      "storageKey": null
    }
  ]
},
v19 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "assets",
  "storageKey": null,
  "args": null,
  "concreteType": "Asset",
  "plural": true,
  "selections": [
    v2,
    v5,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }
  ]
},
v20 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "artist",
  "storageKey": null,
  "args": null,
  "concreteType": "Artist",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "itunes",
      "args": null,
      "storageKey": null
    },
    v2,
    v11,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "bio",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "bandcamp",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "facebook",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "instagram",
      "args": null,
      "storageKey": null
    },
    v4,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "soundcloud",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "spotify",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "twitter",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "wiki",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "youtube",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "homebase",
      "args": null,
      "storageKey": null
    },
    v19
  ]
},
v21 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100,
    "type": "Int"
  }
],
v22 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "terms",
  "storageKey": "terms(first:100)",
  "args": v21,
  "concreteType": "TaxonomyTermConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "TaxonomyTermEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "TaxonomyTerm",
          "plural": false,
          "selections": [
            v2,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "is_highlighted",
              "args": null,
              "storageKey": null
            },
            v4,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "parent_id",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "taxonomy",
              "storageKey": null,
              "args": null,
              "concreteType": "Taxonomy",
              "plural": false,
              "selections": [
                v2,
                v15,
                v4
              ]
            }
          ]
        }
      ]
    }
  ]
},
v23 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "node",
  "storageKey": null,
  "args": null,
  "concreteType": "Collection",
  "plural": false,
  "selections": [
    v2,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    },
    v4,
    v11,
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "category",
      "storageKey": null,
      "args": null,
      "concreteType": "CollectionCategory",
      "plural": false,
      "selections": [
        v2,
        v4
      ]
    },
    v19
  ]
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "association_id",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "selected_version",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v28 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
},
v29 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "license_params",
  "storageKey": null,
  "args": null,
  "concreteType": "LicenseUsageParams",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "spot_count",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "term",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "medium",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "contextual_param",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "contextual_param_type",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "projectUpdate_Mutation",
  "id": null,
  "text": "mutation projectUpdate_Mutation(\n  $input: UpdateProjectInput!\n) {\n  updateProject(input: $input) {\n    project {\n      id\n      is_public\n      name\n      tracks(first: 100) {\n        edges {\n          id\n          version\n          node {\n            id\n            internal_id\n            price\n            base_price\n            title\n            added_to_cart\n            slug\n            duration\n            score\n            boosted_score\n            stems_available\n            customizable\n            matched_exclusions\n            tempos {\n              id\n              name\n              value\n            }\n            assets {\n              id\n              version\n              type\n              file_format\n              path\n              metadata\n            }\n            artist {\n              id\n              name\n              slug\n              bio\n              bandcamp\n              facebook\n              instagram\n              itunes\n              soundcloud\n              spotify\n              twitter\n              wiki\n              youtube\n              homebase\n              assets {\n                id\n                version\n                type\n                file_format\n                path\n                metadata\n              }\n            }\n            terms(first: 100) {\n              edges {\n                node {\n                  id\n                  is_highlighted\n                  name\n                  parent_id\n                  taxonomy {\n                    id\n                    internal_id\n                    name\n                  }\n                }\n              }\n            }\n            collections {\n              edges {\n                node {\n                  id\n                  description\n                  name\n                  slug\n                  category {\n                    id\n                    name\n                  }\n                  assets {\n                    id\n                    version\n                    type\n                    file_format\n                    path\n                    metadata\n                  }\n                }\n                id\n              }\n            }\n            association_id\n            selected_version\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      license_params {\n        spot_count\n        term\n        medium\n        contextual_param\n        contextual_param_type\n      }\n    }\n  }\n}\n",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "updateProject",
          "project",
          "tracks"
        ]
      }
    ]
  },
  "fragment": {
    "kind": "Fragment",
    "name": "projectUpdate_Mutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateProject",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateProjectPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "project",
            "storageKey": null,
            "args": null,
            "concreteType": "Project",
            "plural": false,
            "selections": [
              v2,
              v3,
              v4,
              {
                "kind": "LinkedField",
                "alias": "tracks",
                "name": "__project_tracks_connection",
                "storageKey": null,
                "args": null,
                "concreteType": "ProjectTrackConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ProjectTrackEdge",
                    "plural": true,
                    "selections": [
                      v2,
                      v5,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TrackSearchResult",
                        "plural": false,
                        "selections": [
                          v6,
                          v2,
                          v7,
                          v8,
                          v9,
                          v10,
                          v11,
                          v12,
                          v13,
                          v14,
                          v15,
                          v16,
                          v17,
                          v18,
                          v19,
                          v20,
                          v22,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "collections",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CollectionTrackConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "CollectionTrackEdge",
                                "plural": true,
                                "selections": [
                                  v23
                                ]
                              }
                            ]
                          },
                          v24,
                          v25,
                          v26
                        ]
                      },
                      v27
                    ]
                  },
                  v28
                ]
              },
              v29
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "projectUpdate_Mutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateProject",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateProjectPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "project",
            "storageKey": null,
            "args": null,
            "concreteType": "Project",
            "plural": false,
            "selections": [
              v2,
              v3,
              v4,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tracks",
                "storageKey": "tracks(first:100)",
                "args": v21,
                "concreteType": "ProjectTrackConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ProjectTrackEdge",
                    "plural": true,
                    "selections": [
                      v2,
                      v5,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TrackSearchResult",
                        "plural": false,
                        "selections": [
                          v6,
                          v2,
                          v7,
                          v8,
                          v9,
                          v10,
                          v11,
                          v12,
                          v13,
                          v14,
                          v15,
                          v16,
                          v17,
                          v18,
                          v19,
                          v20,
                          v22,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "collections",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CollectionTrackConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "CollectionTrackEdge",
                                "plural": true,
                                "selections": [
                                  v23,
                                  v2
                                ]
                              }
                            ]
                          },
                          v24,
                          v25,
                          v26
                        ]
                      },
                      v27
                    ]
                  },
                  v28
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "tracks",
                "args": v21,
                "handle": "connection",
                "key": "project_tracks",
                "filters": null
              },
              v29
            ]
          }
        ]
      }
    ]
  }
};
})();
(node/*: any*/).hash = 'a62040275d0b4d3aedfe1a5e92617e31';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/projectUpdate_Mutation.graphql.js